import { useState } from 'react';
import orderBy from 'lodash/orderBy';
import styled from 'styled-components';
import {ReactComponent as ArrowUp} from '../../../../../images/arrow-up.svg';

interface CommentsProps{
  comments: Array<any>
}

const Container = styled.div`
  margin-top: 25px;
  display: flex;
  flex-direction: column;
`
const Header = styled.h5`
  color: #0039BB;
  font-family: Manrope, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
`
const Chevron = styled.span`
  margin-left: 20px;
  color: #0039BB;
  transition: all ease-in-out .15s;
  & path {
    fill: #0039BB;
  }
  &.reverse svg{
    transform: rotate(180deg);
  }
`

const Content = styled.div`
  max-height: 0;
  flex: 1;
  overflow: hidden;
  transition: all ease-in-out .3s;
  white-space: pre-wrap;
  &.open{
    max-height: 300px;
    overflow: auto;
  }
`

const JiraComments = ({ comments }: CommentsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  if (!comments || !comments.length) {
    return null;
  }
  let ordered = orderBy(comments, (com) => new Date(com.created), 'desc');
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  }
  return (
    <Container>
      <Header onClick={toggleOpen}>
        Comments <Chevron className={isOpen ? 'reverse' : ''}><ArrowUp /></Chevron>
      </Header>
      <Content className={isOpen ? 'open' : ''}>
        {ordered.map(com => (
          <div style={{ marginBottom: 8 }} key={com.id}>
            <span style={{ fontWeight: 600 }}>{com.author && com.author.displayName}: </span>
            <span>{com.body}</span>
          </div>
        ))}
      </Content>
    </Container>
  )
}

export default JiraComments;